import ReactivateButton from "./ReactivateButton";
import DeactivateButton from "./DeactivateButton";
import { FC, useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { DeactivateCompanyRequest } from "../../data/interfaces/DeactivateCompanyRequest";
import { ReactivateCompanyRequest } from "../../data/interfaces/ReactivateCompanyRequest";

interface Props {
  companyId: number;
  isActive: boolean;
  deactivatedCompany: DeactivateCompanyRequest;
  reactivatedCompany: ReactivateCompanyRequest;
}

interface Claims {
  roles: string[];
}

const DeactivateReactivateButton: FC<Props> = ({
  isActive,
  deactivatedCompany,
  reactivatedCompany
}: Props) => {
  const { instance } = useMsal();
  const [showButton, setShowButton] = useState<boolean>(false);

  useEffect(() => {
    const claims: Claims | undefined = instance.getActiveAccount()
      ?.idTokenClaims as Claims;

    if (claims.roles.includes("CompanyManager")) {
      setShowButton(true);
    }

    const account = instance.getAllAccounts()[0];
    const user = account.name;
    deactivatedCompany.changedBy = user;
    reactivatedCompany.changedBy = user;

  }, [instance, deactivatedCompany, reactivatedCompany]);

  return (
    <>
      {isActive === true ? (
        <h5>Deactivate Company</h5>
      ) : (
        <h5>Reactivate Company</h5>
      )}      
      {showButton ? (
        isActive === true ? (
          <DeactivateButton deactivatedCompany={deactivatedCompany} />
        ) : (
          <ReactivateButton reactivatedCompany={reactivatedCompany} />
        )
      ) : (
        <></>
      )}
    </>
  );
};

export default DeactivateReactivateButton;
